<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="my-2" >
                <template #p-2>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;\n"' class="my-3 border-bottom pb-2" >
                <template #default>ویرایش کاربر   </template>
                </m-h5><m-user-profile-1 v-bind='{...{"advanceDescription":true,"advanceDescriptionInputs":"[   {     \"name\": \"\u0627\u0633\u062a\u0627\u0646\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": true,     \"type\": \"text\"   },   {     \"name\": \"\u0634\u0647\u0631\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": true,     \"type\": \"text\"   },   {     \"name\": \"\u0622\u062f\u0631\u0633\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": true,     \"type\": \"text\"   },   {     \"name\": \"\u062a\u0648\u0636\u06cc\u062d\u0627\u062a\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": false,     \"type\": \"editor\",     \"config\": {       \"image\": true     }   } ]","loadUserProfile":true},...{}}' :style='"border:1px solid #cfcfcf;\nborder-radius:15px"' class="bg-white m-2 p-4 profile-sec" ></m-user-profile-1></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mUserProfile1 from '@moeinmdn/miw-alpha-components/src/package/User/Profile/UserProfile1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mH5,mUserProfile1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
